import React from 'react';

function ContainerLayout({children}) {
    return (
        <div className=' xl:max-w-screen-xl md:max-w-screen-md mx-auto px-5'>
            {children}
        </div>
    );
}

export default ContainerLayout;